<template>
    <div class="item-type-media-set">
        <div class="set-container pt-5">
            <!-- Media sets //-->
            <template v-if="hasSets">
                <h4 class="media-gallery-heading">Collections</h4>
                <gallery item-classes="media-item-container col-xs-12 col-md-6 col-lg-4" :items="item.mediaSets" :pad-bottom="false">

                    <template #item="slotProps">
                        <media-item
                            :item="slotProps.mediaItem"
                            :item-route="getSetItemRoute(slotProps.mediaItem)"
                            condensed
                        >
                            <template #select="{ item }">
                                <input
                                    type="checkbox"
                                    :id="`checkbox-${item.id}`"
                                    class="gallery-item-checkbox"
                                    v-model="selectedItems"
                                    :value="{item, size: getItemFilesize(item)}"
                                    @change="$emit('update:selected', {item, size: getItemFilesize(item)})"
                                >
                                <label class="gallery-item-checkbox-label" :for="`checkbox-${item.id}`"></label>
                            </template>

                            <template #meta="{ item }">
                                <button class="btn btn-sm btn-default media-item-download hidden-ios" @click.prevent="doDownload(item)">
                                    <i class="fa fa-cloud-download"></i> Download
                                </button>

                            </template>
                        </media-item>
                    </template>
                </gallery>
            </template>

            <!-- Media items //-->
            <template v-if="hasMedia">
                <h4 class="media-gallery-heading">Media Items</h4>
                <gallery item-classes="media-item-container col-xs-12 col-md-6 col-lg-4" :items="item.mediaItems" :pad-bottom="false">
                    <template #item="slotProps">
                        <media-item
                            :item="slotProps.mediaItem"
                            :item-route="getMediaItemRoute(slotProps.mediaItem.id)"
                        >

                            <template #select="{ item }">
                                <input
                                    type="checkbox"
                                    :id="`checkbox-${item.id}`"
                                    class="gallery-item-checkbox"
                                    v-model="selectedItems"
                                    :value="{item, size: getItemFilesize(item)}"
                                    @change="$emit('update:selected', {item, size: getItemFilesize(item)})"
                                >
                                <label class="gallery-item-checkbox-label" :for="`checkbox-${item.id}`"></label>
                            </template>

                            <template #meta="{ item }">
                                <button class="btn btn-sm btn-default media-item-download hidden-ios" @click.prevent="doDownload(item)">
                                    <i class="fa fa-cloud-download"></i> Download
                                </button>
                            </template>
                        </media-item>
                    </template>
                </gallery>
            </template>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Gallery from '@/components/media/Gallery';
import MediaItem from '@/components/media/MediaItem';

const { mapState } = createNamespacedHelpers('app/share');

// mixins
import download from '@/components/media/app/mixins/download';

export default {
    name: 'MediaSet',
    mixins: [download],
    components: {
        Gallery,
        MediaItem,
    },
    props: {
        item: {
            required: true,
            type: Object,
        },
        selected: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            selectedItems: [],
        };
    },
    computed: {
        ...mapState({
            share: (state) => state.item,
        }),
        hasMedia() {
            return this.item && this.item.mediaItems.length > 0;
        },
        hasSets() {
            return this.item && this.item.mediaSets.length > 0;
        },
    },
    watch: {
        selected(newValue) {
            this.selectedItems = newValue;
        },
    },
    methods: {
        getMediaItemRoute(media_id) {
            let route = `/s/${this.share.id}/c/${this.item.id}/m/${media_id}`;
            if (this.item.hasParent) {
                route = `/s/${this.share.id}/p/${this.item.parent.id}/c/${this.item.id}/m/${media_id}`;
            }

            return route;
        },
        getSetItemRoute(item) {
            const route = {name: 'set-view', params: {id: this.share.id, set_id: item.id}};
            if (item.hasParent) {
                route.name = 'nested-set-view';
                route.params.parent_id = item.parent.id;
            }
            return route;
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~/sass/_variables';

.item-type-media-set {
    height: 100%;
    width: 100%;

    .set-container {
        max-width: 1170px;
        margin-right: auto;
        margin-left: auto;
        padding-right: 15px;
        padding-left: 15px;
    }
}
</style>

